// @flow
import { toUIOperatorMapper } from "../..";
import type { ToUI } from "../..";
import type {
  UIRule,
  ServerRule,
  UIOperatorList,
} from "../types";

export default class MultivalueBased implements ToUI<UIRule, ServerRule> {
  rule: ServerRule;

  constructor(rule: ServerRule) {
    this.rule = rule;
  }

  convert(): UIRule {
    const field = Object.keys(this.rule)[0];
    const label = field;

    const serverRule = this.rule[field];
    const serverOperator = Object.keys(serverRule)[0];

    // $FlowFixMe
    const operator: UIOperatorList = toUIOperatorMapper[serverOperator];
    const value: string[] = serverRule[serverOperator];

    const type: string = "string";

    return {
      field,
      label,
      type,
      operator,
      value,
    };
  }
}
